import { InfoCircleFilled } from "@ant-design/icons";
import { Button, ButtonColorType } from "@/ui-components/commonComponents/Button/Button";
import SectionHeader from "@/shared/components/assessment/report/SectionHeader/SectionHeader";
import styles from "./styles.module.css";

interface DevelopEmptyStateProps {
  // Resets the Develop report to English. Omitted on the print path, where the button is hidden.
  onViewInEnglish?: () => void;
}

// Whole-report empty state shown when the selected locale has no Develop content for the template.
// Per design, we surface a single message rather than a sea of empty per-section blocks, with a way
// back to English when interactive (the button is hidden on the print path).
//
// This is admin-only navigation chrome (PRINT is hidden, nothing is shared), so its copy stays in
// English regardless of the selected language — hardcoded, not routed through the i18n catalog.
export default function DevelopEmptyState({ onViewInEnglish }: DevelopEmptyStateProps) {
  return (
    <div className={styles.developContainer}>
      <SectionHeader title="Development Insights" hidePrint />
      <div className={styles.emptyState}>
        <InfoCircleFilled className={styles.helpIcon} aria-hidden="true" />
        <p>The Develop report isn&apos;t available in the selected language yet.</p>
        {onViewInEnglish && (
          <Button colorType={ButtonColorType.dark} onClick={onViewInEnglish}>
            View in English
          </Button>
        )}
      </div>
    </div>
  );
}
